import axios from "axios";

/** True for intentional abort/cancel (effect cleanup, navigation, Strict Mode remount). */
export default function isRequestAborted(error: unknown): boolean {
  if (axios.isCancel(error)) {
    return true;
  }
  if (error instanceof Error) {
    if (error.message === "aborted") {
      return true;
    }
    if (error.name === "CanceledError") {
      return true;
    }
  }
  if (typeof error === "object" && error !== null && "code" in error) {
    return (error as { code?: string }).code === "ERR_CANCELED";
  }
  return false;
}
